import { useActiveNotificationsStore } from "@/stores/notificationStore";
import { useAssetStore } from "@/stores/assetStore.js";
import { useFeatureFlagStore } from '@/stores/featureFlagStore.js';
import { useForecastStore } from '@/stores/forecastStore.js';
import { useMapStore } from "@/stores/mapStore.js";
import { useSettingStore } from "@/stores/settingStore.js";

export const clearStores = () => {
    const activeNotificationStore = useActiveNotificationsStore();
    const assetStore = useAssetStore();
    const featureFlagStore = useFeatureFlagStore();
    const forecastStore = useForecastStore();
    const mapStore = useMapStore();
    const settingStore = useSettingStore();

    assetStore.clear();
    featureFlagStore.clear();
    forecastStore.clear();
    mapStore.clear();
    settingStore.clear();
    activeNotificationStore.clear();
};